import { useMemo } from "react";
import { useSelector } from "react-redux";

import Email from "@mapmycustomers/shared/types/email/Email";

import { getMe } from "@app/store/iam";
import { getUsersOfEntireOrganization } from "@app/store/members";
import { getEmailNylasInfo } from "@app/store/nylas";

const useEmailUser = (email: Email) => {
  const me = useSelector(getMe);
  const emailNylasInfo = useSelector(getEmailNylasInfo);
  const organizationUsers = useSelector(getUsersOfEntireOrganization);

  // workaround for the case when emailThread.userId is null and email was send by current user
  const emailUserId =
    email.userId ?? (emailNylasInfo?.connectedEmail === email.from[0].email ? me!.id : undefined);

  return useMemo(
    () => (emailUserId ? organizationUsers.find((user) => user.id === emailUserId) : undefined),
    [organizationUsers, emailUserId]
  );
};

export default useEmailUser;
